<template>
<div>
    <v-container fluid grid-list-md class="dashboard">
        <v-layout row wrap>
           <v-flex xs12>
                <v-snackbar
                    v-model="alert" 
                    color="green lighten-2" 
                    class="white--text" 
                    top outlined dense 
                    type="success" text>
                    {{ message }}
                    <v-btn color="white" text  @click="alert = false">  <v-icon color="maroon">mdi-close</v-icon></v-btn>
                </v-snackbar>
                 <v-snackbar
                    v-model="alert_error" 
                    color="red lighten-2" 
                    class="white--text" 
                    top outlined dense
                    type="error" text>
                    {{ error }}
                    <v-btn color="white"  text  @click="alert_error = false"> Close</v-btn>
                </v-snackbar>
           </v-flex>
            <v-flex xs12 sm12 md5>
                <v-progress-linear v-show="this.loaders.detail_loader" slot="progress" color="blue" indeterminate></v-progress-linear>
                <v-card outlined class="pa-2" height="100%">
                    <div>
                        <v-layout row wrap fill-height class="light-bg pa-2">
                            <v-flex>
                                <p class="text-color pb-0">Registration Details</p>
                            </v-flex>
                            <v-flex>
                                <div class="float_right">
                                    <v-menu bottom left>
                                        <template v-slot:activator="{ on }">
                                            <v-btn dark icon v-on="on">
                                                <v-icon>mdi-dots-vertical</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list class="fullwidthbutton">
                                            <v-list-item >
                                                <v-list-item-title>
                                                    <v-btn text small color="primary"  :disabled="isDisabled(registration_details.from_date)" :to="`/registrations/edit/${registration_details.id}`">Edit</v-btn>
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-title>
                                                    <v-btn text small color="primary" :to="{ name:'addRegistration',params: { id:registration_details.id, dublicate:true } }">Duplicate</v-btn>
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item v-if="registration_details.status != 'approved'">
                                                <v-list-item-title>
                                                    <v-btn small text color="warning" @click="updateRegistrationStatus('approved')">Approve</v-btn>
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item v-if="registration_details.status != 'rejected'">
                                                <v-list-item-title>
                                                    <v-btn small text color="error" @click="updateRegistrationStatus('rejected')">Reject</v-btn>
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item v-if="registration_details.type == 'vip'">
                                                <v-list-item-title>
                                                    <v-btn small text color="error" @click="resendsms()">Resend Invite SMS</v-btn>
                                                </v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap class="mb-3">
                            <v-flex xs3 sm2 md2 class="p-5">
                                <v-flex v-if="registration_details.image">
                                    <v-img :src="storage_path()+registration_details.image.path" max-width="150" max-height="150"></v-img>
                                </v-flex>
                                <v-flex v-else>
                                    <v-img src="@/assets/images/index.png" max-width="150" max-height="150"></v-img>
                                </v-flex>
                            </v-flex>
                            <v-flex xs8 sm9>
                                <v-layout row wrap>
                                    <v-flex xs12 v-if="registration_details.record!=null">
                                        <v-list-item dense>
                                            <v-list-item-content>
                                                <h3 class="text-color mt-2">{{ registration_details.record.name |capitalize}}</h3>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-list-item dense v-if="registration_details.record!=null">
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Mobile</v-list-item-subtitle>
                                            <v-list-item-title v-if="registration_details.record.mobile!=null">{{this.registration_details.record.mobile}}</v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Email</v-list-item-subtitle>
                                            <v-list-item-title v-if="registration_details.record.email!=null">{{this.registration_details.record.email}}</v-list-item-title>
                                            <v-list-item-title v-else>-</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row wrap class="mt-3">
                            <v-flex xs12>
                                <div>
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Type</v-list-item-subtitle>
                                            <v-list-item-title v-if="registration_details.type!=null">{{this.registration_details.type |capitalize}}</v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Purpose</v-list-item-subtitle>
                                            <v-list-item-title v-if="registration_details.purpose!=null">{{this.registration_details.purpose |capitalize}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </div>
                                <div v-if="this.registration_details.type=='vendor'" class="mb-3">
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>From Date</v-list-item-subtitle>
                                            <v-list-item-title v-if="registration_details.from_date!=null">{{formatDate(this.registration_details.from_date)}}</v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>To Date</v-list-item-subtitle>
                                            <v-list-item-title v-if="registration_details.to_date!=null">{{formatDate(this.registration_details.to_date)}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </div>
                                <div v-if="this.registration_details.type=='vip'" class="mb-3">
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Visit Date</v-list-item-subtitle>
                                            <v-list-item-title v-if="registration_details.from_date!=null">{{formatDate(this.registration_details.from_date)}}</v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Visit Time</v-list-item-subtitle>
                                            <v-list-item-title v-if="registration_details.to_date!=null">{{formatTime(this.registration_details.from_date)}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </div>
                                <div>
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Status</v-list-item-subtitle>
                                            <v-list-item-title v-if="registration_details.status!=null">{{this.registration_details.status |capitalize}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </div>
                                <v-divider></v-divider>
                                <div class="mt-3" v-if="registration_details.created_by!=null">
                                    <v-list-item dense>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Registered By</v-list-item-subtitle>
                                            <v-list-item-title v-if="registration_details.created_by.username!=null">{{this.registration_details.created_by.username |capitalize}}</v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>Registered At</v-list-item-subtitle>
                                            <v-list-item-title v-if="registration_details.created_by.created_at!=null">{{formatDateTime(this.registration_details.created_at)}}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </div>
                                <div v-else></div>

                            </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex>
            <!-- <v-flex xs12 sm12 md7>
                <v-card outlined class="pa-2" height="100%">
                    <div>
                        <v-layout row wrap fill-height class="light-bg pa-2">
                            <v-flex>
                                <p class="text-color pb-0">Visit</p>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex> -->   

            <v-flex xs12 sm12 md7>
                <v-card outlined class="pa-2" height="100%">
                    <div>
                        <v-layout row wrap fill-height class="light-bg pa-2">
                            <v-flex xs9>
                                <p class="text-color">Visits</p>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row wrap fill-height class="innerheader">
                            <v-flex xs12>
                                <v-data-table :headers="visit_headers" 
                                :items="visitor_related_visits"
                                 item-key="id"
                                  class="elevation-1" 
                                 :loading="is_loading" 
                                 :options.sync="options" 
                                 :footer-props="{'items-per-page-options': [5,10,15,20,40]}"
                                 :items-per-page="5">
                                    <template v-slot:body="{ items }" v-if="!is_loading && count!='0'">
                                        <tbody>
                                            <tr v-for="item in items" :key="item.id">
                                                <td v-if="item.image">
                                                    
                                                        <v-avatar size="36">
                                                            <img :src="storage_path()+item.image.path" @click="fullWidthImage(item.image.path)">
                                                        </v-avatar>
                                                    
                                                </td>
                                                <td v-else>
                                                   
                                                        <v-avatar size="36">
                                                            <img src="@/assets/images/index.png">
                                                        </v-avatar>
                                                    
                                                </td>
                                                <td v-if="item.type">{{ item.type.toUpperCase().replace(/_/g, " ")}}</td>
                                                <td>{{ formatDateTime(item.time)}}</td>
                                                <td v-if="registration_details.type=='visitor'" v-show="role!='Office Admin'">
                                                    <router-link :to="{ name:'showOfficeDetails',params: { id:registration_details.office.id } }">{{ registration_details.office.name }}</router-link>
                                                </td>
                                                <td v-else> - </td>

                                            </tr>
                                        </tbody>
                                    </template>
                                    <template v-slot:loading> Loading... Please wait </template>
                                    <template v-slot:no-results> No data available </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex> 

        </v-layout>
        <!-- Image Dialog -->

    <v-dialog
      v-model="image_dialog_box"
      max-width="290"
      max-height="290"
    >
      <v-card>
         <v-img :src="storage_path()+image_path" ></v-img> 
      </v-card>
    </v-dialog>
    </v-container>
</div>
</template>

<script>
export default {
    methods: {
           isDisabled:function(from_date) {
          var current_date = moment().format('YYYY-MM-DD');
          var date = moment(from_date).format('YYYY-MM-DD');
    return date<current_date;
       
      },       
        getRegistrationDetails() {
            this.is_loading = true;
            axios.get(`${process.env.VUE_APP_API_URL}/api/registrations/` + this.$route.params.id).then(response => {
                    if (response.data.status == 1) {  
                        
                        this.registration_details = response.data.registration_details;
                        
                         
                        if(this.registration_details.type == 'vendor')
                        {
                        
                            
                            this.visitor_related_visits = response.data.visits;
                           
                            
                        }
                        else{
                            this.visitor_related_visits = response.data.registration_details.visits;
                        }
                        this.count = this.visitor_related_visits.length;
                       
                       this.is_loading = false;

                    }
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {

                });
        },
        resendsms() {

            axios.post(`${process.env.VUE_APP_API_URL}/api/registrations/resendsms`, this.registration_details)
                .then(response => {
                    if (response.data.status == 1) {
                        this.alert=true;
                        this.message = response.data.message;
                    }
                    if (response.data.status == 0) {
                        this.alert=true;
                        this.message = response.data.message;
                    }
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {

                });
        },
        fullWidthImage(item_image){
            
            this.image_dialog_box =true;
            this.image_path = item_image;
            
        },
        updateRegistrationStatus(status) {
            this.registration_details.status = status;
            axios
                .post(`${process.env.VUE_APP_API_URL}/api/registrations/updatestatus`, this.registration_details).then((response) => {
                    if (response.data.status == 1) { 
                        this.$router.push({
                            name: 'showRegistrationDetails',
                            params: {
                                id: response.data.registration_details.id,
                                success_message:'Vendor Status Updated'
                            }
                        });

                    }

                }).catch((error) => {
                    console.log(error);

                }).finally(() => {
                    {

                    }
                });
        },
        getColumnfilter() {
            if (this.role == 'Office Admin') {
                this.visit_headers = [{
                        text: 'Image',
                        align: 'left',
                        value: 'image',
                    },
                    {
                        text: 'Type',
                        value: 'type'
                    },
                    {
                        text: 'Time',
                        value: 'time'
                    },
                ];
            } else {
                this.visit_headers = [{
                        text: 'Image',
                        align: 'left',
                        value: 'image',
                    },
                    {
                        text: 'Type',
                        value: 'type'
                    },
                    {
                        text: 'Time',
                        value: 'time'
                    },
                    {
                        text: 'Office',
                        value: 'office_id',
                        sortable: false,
                    },
                ];
            }
        }
    },
    data() {
        return {
           error: '',
           count:'',
            default_visitor_image: "/visits_images/index.png",
            loaders: {
                detail_loader: false,
            },
            image_dialog_box:false,
            image_path:"",
            is_loading: false,
            total_items: 0,
            options: {},
            role: '',

            registration_id: '',
            registration_details: { record:{},office:{},created_by:{}},

            visitor_id: '',
            visitor_details: '',
            visitor_related_visits: [{}],

            visit_headers: [],
            message:'',
            alert: false,
            alert_error:false
            
        }
    },
    mounted() {
        this.role = localStorage.getItem('visitor_management_role');
        if(this.$route.params.success_message!=null) 
        {    this.alert=true;
            this.message = this.$route.params.success_message;
        }
        this.getColumnfilter();
        this.getRegistrationDetails();

    },
}
</script>

<style scoped>

</style>